import { render, staticRenderFns } from "./templates.vue?vue&type=template&id=51a9bc60&"
import script from "./templates.vue?vue&type=script&lang=js&"
export * from "./templates.vue?vue&type=script&lang=js&"
import style0 from "./templates.vue?vue&type=style&index=0&id=51a9bc60&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports